import { z } from 'zod';
// Activity event types exposed by the API
// The DB uses a narrower set; we map POST types to DB types in the route.
export const ActivityTypeSchema = z.enum([
    'call_made',
    'call_answered',
    'call_no_answer',
    'whatsapp_sent',
    'whatsapp_replied',
    'email_sent',
    'note_added',
    'stage_changed',
    'meeting_scheduled',
    'viewing_done',
    'offer_made',
    'deal_closed',
    'dropped',
]);
// DB-level event types (from schema CHECK constraint — migration 013 expanded set)
export const DbActivityTypeSchema = z.enum([
    'call',
    'no_answer',
    'whatsapp',
    'note',
    'comment',
    'meeting',
    'email',
    'viewing',
    'offer',
    'followup',
    'flag',
    'unit_update',
    'status_change',
    'assignee_change',
    'tag_change',
    'phone_added',
    'reminder',
    'reminder_done',
    'assignment',
    'edit',
    'import',
    'stage_change',
]);
// Map API type → DB type
export const API_TO_DB_TYPE = {
    call_made: 'call',
    call_answered: 'call',
    call_no_answer: 'call',
    whatsapp_sent: 'whatsapp',
    whatsapp_replied: 'whatsapp',
    email_sent: 'note',
    note_added: 'note',
    stage_changed: 'stage_change',
    meeting_scheduled: 'note',
    viewing_done: 'note',
    offer_made: 'note',
    deal_closed: 'stage_change',
    dropped: 'stage_change',
};
// POST /api/activity body
export const CreateActivitySchema = z.object({
    landlord_id: z.number().int().positive(),
    type: ActivityTypeSchema,
    payload: z.record(z.unknown()).optional(),
});
// Activity query params
export const ActivityQuerySchema = z.object({
    agent_id: z.coerce.number().int().positive().optional(),
    landlord_id: z.coerce.number().int().positive().optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    type: ActivityTypeSchema.optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
// Activity event response shape
export const ActivityEventSchema = z.object({
    id: z.number().int(),
    landlordId: z.number().int(),
    userId: z.number().int().nullable(),
    userName: z.string().nullable(),
    type: DbActivityTypeSchema,
    apiType: z.string().nullable(), // original API type from payload
    detail: z.record(z.unknown()).nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=activity.js.map